import { render, staticRenderFns } from "./DeletePlayer.vue?vue&type=template&id=f70a1a6c&"
import script from "./DeletePlayer.vue?vue&type=script&lang=js&"
export * from "./DeletePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports